<template>
  <div class="authentication-bar">
    <button @click="signIn" class="button">Add account</button>
    <button v-if="loggedIn" @click="signOut" class="button">Sign out</button>
  </div>
</template>

<script>
export default {
  name: 'authentication-bar',

  data () {
    return {
      // Bool indicating if the user is logged in.
      loggedIn: false
    }
  },

  methods: {
    signIn: function () {
      this.$gapi.addAccount()
      this.$emit('closeSidebar')
    },

    signOut: function () {
      this.$gapi.signOut()
    },

    updateState: async function () {
      this.loggedIn = this.$gapi.isLoggedIn()
    }
  },

  mounted () {
    this.$gapi.addAuthStateChangeCallback(this.updateState.bind(this))
    this.updateState()
  }
}
</script>

<style scoped>
button {
  border: 1px solid #999;
  color: #444;
  padding: 0.3em 0.6em;
  margin-left: 1em;
  background-color: #fff;
  user-select: none;
}
</style>
